import { CHAINSELECTORCONFIG_SUCCESS, CHAINSELECTORCONFIG_ERROR, CHAINSELECTORCONFIG_CREATE, CHAINSELECTORCONFIG_CREATE_SUCCESS, CHAINSELECTORCONFIG_CREATE_ERROR, CHAINSELECTORCONFIG_DELETE, CHAINSELECTORCONFIG_DELETE_SUCCESS, CHAINSELECTORCONFIG_DELETE_ERROR, EDIT_CHAINSELECTORCONFIG, EDIT_CHAINSELECTORCONFIG_SUCCESS, EDIT_CHAINSELECTORCONFIG_ERROR, CHAINSELECTORCONFIG_LIST, CHAINSELECTORCONFIG_UPDATE_DATA, MULTIPLEMODEL_LIST, MULTIPLEMODEL_LIST_SUCCESS, MULTIPLEMODEL_LIST_ERROR } from './constants';

export default function chainselectorReducer(state, action) {
	let chainselectorconfigdata = [];
	let multimod = [];
	switch (action.type) {
	
	case CHAINSELECTORCONFIG_UPDATE_DATA :
		return { ...state, chainselectorconfigUpdateData : action.payload };
	case CHAINSELECTORCONFIG_CREATE:
		return { ...state, loading : true, error : false };
	case CHAINSELECTORCONFIG_CREATE_SUCCESS :
		return { ...state, loading : false, error : false};
	case CHAINSELECTORCONFIG_CREATE_ERROR :
		return { ...state, loading : false, error : true };
	case CHAINSELECTORCONFIG_DELETE :
		return { ...state, loading : true, error : false};
	case CHAINSELECTORCONFIG_DELETE_SUCCESS :
		return { ...state, loading : false, error : false };
	case CHAINSELECTORCONFIG_DELETE_ERROR :
		return { ...state, loading : false, error : true };

	case EDIT_CHAINSELECTORCONFIG :
		return {...state, loading : true , error : false};
	case EDIT_CHAINSELECTORCONFIG_SUCCESS :
		return {...state, loading : false , error : false};
	case EDIT_CHAINSELECTORCONFIG_ERROR :
		return {...state, loading : false , error : true};

	case CHAINSELECTORCONFIG_LIST:
		return {...state, loading : false , error : false};
	case CHAINSELECTORCONFIG_SUCCESS:
		if (action.payload && action?.payload?.data?.length > 0) {
			
			action?.payload?.data?.map( (item) => {
				let data = {};
				data.id = item.id ? item.id : null;
				data.name = item.name,
				data.configs = item.configs,
				data.pipelineId = item.pipelineId ? item.pipelineId : null;
				data.channelinfoId = item.channelinfoId ? item.channelinfoId : null;
				data.pidsinfoId = item.pidsinfoId ? item.pidsinfoId : null;
				data.channelname = item?.channelinfo && item?.channelinfo?.name ? item?.channelinfo?.name : ''; 
				data.pidsinfo = item?.pidsinfo && item?.pidsinfo?.name ? item?.pidsinfo?.name : ''; 
				data.multiplemodelsId = item.multiplemodelsId ? item.multiplemodelsId : null;
				data.multiplemodelsname = item?.pidsinfo && item?.multiplemodels?.name ? item?.multiplemodels?.name : ''; 
				data.chainselectorId = item.chainselectorId ? item.chainselectorId : null;
				data.chainselectorname = item?.chainselector && item?.chainselector?.name ? item?.chainselector?.name : ''; 
				
				return chainselectorconfigdata.push(data);
			});
			return { ...state, chainselectorconfigdata:chainselectorconfigdata ,  loading: false, error: false };
		}
		else {
			if (action.payload && action.payload.data.length === 0) {
				return { ...state, chainselectorconfigdata: [], pending: false, error: false };
			} else {
				return { ...state, pending: false, error: true };
			}
		}

	case CHAINSELECTORCONFIG_ERROR:
		return {...state, loading : false , error : true};
	
	case MULTIPLEMODEL_LIST:
		return { ...state, pending: true };
      
	case MULTIPLEMODEL_LIST_SUCCESS:
        
		if (action.payload && action?.payload?.data?.length > 0) {
			
			action?.payload?.data?.map( (item) => {
				let data = {};
				data.id = item.id ? item.id : 0;
				data.name = item && item?.name && item?.name ? item.name : '';
				return multimod.push(data);
			});
          
			return { ...state, multimod: multimod, pending: false, error: false };
		} else {
			if (action.payload && action.payload.data.length === 0) {
				return { ...state, multimod: [], pending: false, error: false };
			} else {
				return { ...state, pending: false, error: true };
			}
		}
      
	case MULTIPLEMODEL_LIST_ERROR:
		return { ...state, pending: false, error: true };
	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}